import { store } from '@/firebase'
import { CollectionName } from '@WombatTechnology/nitte-time-lib'
import { collection } from 'firebase/firestore'

export class StripeCheckoutSession {
  static collection(uid: string) {
    return collection(
      store,
      `${CollectionName.Stripe.Customers}/${uid}/${CollectionName.Stripe.CheckoutSessions}`
    )
  }
}
